import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-100/50">
      <div className="w-full px-6 md:px-10 py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-12 relative overflow-hidden">
            <div className="absolute -top-8 -right-8 w-24 h-24 bg-primary-100/40 rounded-full -rotate-12"></div>
            <div className="absolute -bottom-6 -left-6 w-20 h-20 bg-accent-100/40 rounded-full rotate-12"></div>

            <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8">
              <div className="md:col-span-4">
                <Link to="/" className="inline-block mb-4">
                  <span className="font-heading text-xl font-bold text-foreground-900">
                    Kakobuy<span className="text-primary-500">Finds</span>
                  </span>
                </Link>
                <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
                  {t('footer.description')}
                </p>
              </div>

              <div className="md:col-span-2">
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">{t('footer.quick_links')}</h4>
                <ul className="space-y-2.5">
                  <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.home')}</Link></li>
                  <li><Link to="/artykul/kakobuy-spreadsheet-poradnik/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.article')}</Link></li>
                  <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.spreadsheet')}</a></li>
                </ul>
              </div>

              <div className="md:col-span-3">
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">{t('footer.categories_footer')}</h4>
                <div className="grid grid-cols-2 gap-2.5">
                  {categories.slice(0, 8).map((cat) => (
                    <a
                      key={cat.seq}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>

              <div className="md:col-span-3">
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">{t('footer.resources')}</h4>
                <ul className="space-y-2.5">
                  <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">{t('nav.buy_now')}</a></li>
                  <li><span className="text-sm text-foreground-500">{t('footer.privacy')}</span></li>
                  <li><span className="text-sm text-foreground-500">{t('footer.disclaimer')}</span></li>
                </ul>
              </div>
            </div>

            <div className="relative mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">{t('footer.copyright')}</p>
              <div className="flex items-center gap-4">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-global-line text-sm"></i>
                </a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-external-link-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}